export enum ServiceType {
  Undefined = "Undefined",
  WorkerService = "WorkerService",
  MembershipManagementService = "MembershipManagementService",
  MembershipLoyaltyService = "MembershipLoyaltyService",
}
